// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TablePagination-module__font-s-10___zwu9f {
  font-size: 10px !important;
}

.TablePagination-module__font-s-12___t9jY0 {
  font-size: 12px !important;
}

.TablePagination-module__font-s-13___ieKm3 {
  font-size: 13px !important;
}

.TablePagination-module__font-s-14___Wox6M {
  font-size: 14px !important;
}

.TablePagination-module__font-s-15___w72ng {
  font-size: 15px !important;
}

.TablePagination-module__font-s-16___yfVb5 {
  font-size: 16px !important;
}

.TablePagination-module__font-s-18___LZhli {
  font-size: 18px !important;
}

.TablePagination-module__font-s-20___BgY9y {
  font-size: 20px !important;
}

.TablePagination-module__font-s-22___bLHxd {
  font-size: 22px !important;
}

.TablePagination-module__font-s-28___GsFe7 {
  font-size: 28px !important;
}

.TablePagination-module__font-w-400___BrHGw {
  font-weight: 400 !important;
}

.TablePagination-module__font-w-500___dFZTq {
  font-weight: 500 !important;
}

.TablePagination-module__font-w-600___dFoOm {
  font-weight: 600 !important;
}

.TablePagination-module__font-w-700___rP0a5 {
  font-weight: 700 !important;
}

.TablePagination-module__p-5___ix7TR {
  padding: 5px !important;
}

.TablePagination-module__p-12___rch1B {
  padding: 12px !important;
}

.TablePagination-module__p-16___WwLRc {
  padding: 16px !important;
}

.TablePagination-module__p-30___kaBzE {
  padding: 30px !important;
}

.TablePagination-module__p-b-0___aS9nk {
  padding-bottom: 0 !important;
}

.TablePagination-module__p-b-5___YqFPp {
  padding-bottom: 5px !important;
}

.TablePagination-module__p-b-10___KFgmQ {
  padding-bottom: 10px !important;
}

.TablePagination-module__p-b-12___z5WwU {
  padding-bottom: 12px !important;
}

.TablePagination-module__p-b-16___fQbvL {
  padding-bottom: 16px !important;
}

.TablePagination-module__p-b-18___nDhp8 {
  padding-bottom: 18px !important;
}

.TablePagination-module__p-b-20___XLNZr {
  padding-bottom: 20px !important;
}

.TablePagination-module__p-b-25___PCURg {
  padding-bottom: 25px !important;
}

.TablePagination-module__p-b-30___LxHCE {
  padding-bottom: 30px !important;
}

.TablePagination-module__p-b-50___ia85f {
  padding-bottom: 50px !important;
}

.TablePagination-module__p-t-0___la6_p {
  padding-top: 0 !important;
}

.TablePagination-module__p-t-12___eSOCn {
  padding-top: 12px !important;
}

.TablePagination-module__p-t-16___l12w3 {
  padding-top: 16px !important;
}

.TablePagination-module__p-t-18___rm5ww {
  padding-top: 18px !important;
}

.TablePagination-module__p-t-20___njxbO {
  padding-top: 20px !important;
}

.TablePagination-module__p-t-30___uL9jX {
  padding-top: 30px !important;
}

.TablePagination-module__p-t-40___OGFJj {
  padding-top: 40px !important;
}

.TablePagination-module__p-t-50___Hs9k1 {
  padding-top: 50px !important;
}

.TablePagination-module__p-l-20___nJ8N8 {
  padding-left: 20px !important;
}

.TablePagination-module__p-l-30___bDRqQ {
  padding-left: 30px !important;
}

.TablePagination-module__p-l-40___H043i {
  padding-left: 40px !important;
}

.TablePagination-module__p-r-16___h_W9B {
  padding-right: 16px !important;
}

.TablePagination-module__p-r-20___XkYbs {
  padding-right: 20px !important;
}

.TablePagination-module__p-r-30___r61bv {
  padding-right: 30px !important;
}

.TablePagination-module__p-r-50___HMMbx {
  padding-right: 50px !important;
}

.TablePagination-module__p-r-60___ts0VB {
  padding-right: 60px !important;
}

.TablePagination-module__m-b-1___p4PwW {
  margin-bottom: 1px !important;
}

.TablePagination-module__m-b-2___gk7Me {
  margin-bottom: 2px !important;
}

.TablePagination-module__m-b-6___O0ilU {
  margin-bottom: 6px !important;
}

.TablePagination-module__m-b-8___YSNUB {
  margin-bottom: 8px !important;
}

.TablePagination-module__m-b-10___ECNlA {
  margin-bottom: 10px !important;
}

.TablePagination-module__m-b-14___oUfHP {
  margin-bottom: 14px !important;
}

.TablePagination-module__m-b-16___eJZhj {
  margin-bottom: 16px !important;
}

.TablePagination-module__m-b-20___17Qjp {
  margin-bottom: 20px !important;
}

.TablePagination-module__m-b-22___rJuNB {
  margin-bottom: 22px !important;
}

.TablePagination-module__m-b-24___vjQYa {
  margin-bottom: 24px !important;
}

.TablePagination-module__m-b-30___kWt8o {
  margin-bottom: 30px !important;
}

.TablePagination-module__m-b-32___pRP1f {
  margin-bottom: 32px !important;
}

.TablePagination-module__m-b-40___Cdsps {
  margin-bottom: 40px !important;
}

.TablePagination-module__m-t-2___jDtGC {
  margin-top: 2px !important;
}

.TablePagination-module__m-t-3___AmTW0 {
  margin-top: 3px !important;
}

.TablePagination-module__m-t-4___nlGIz {
  margin-top: 4px !important;
}

.TablePagination-module__m-t-5___dljOZ {
  margin-top: 5px !important;
}

.TablePagination-module__m-t-8___mzqd5 {
  margin-top: 8px !important;
}

.TablePagination-module__m-t-10___DVRZx {
  margin-top: 10px !important;
}

.TablePagination-module__m-t-15___MuTY4 {
  margin-top: 15px !important;
}

.TablePagination-module__m-t-16___wvh2S {
  margin-top: 16px !important;
}

.TablePagination-module__m-t-20___xivAq {
  margin-top: 20px !important;
}

.TablePagination-module__m-t-22___gyyFa {
  margin-top: 22px !important;
}

.TablePagination-module__m-t-30___P8fYU {
  margin-top: 30px !important;
}

.TablePagination-module__m-t-32___ornZF {
  margin-top: 32px !important;
}

.TablePagination-module__m-l-auto___e2cd3 {
  margin-left: auto !important;
}

.TablePagination-module__m-l-4___QVEnQ {
  margin-left: 4px !important;
}

.TablePagination-module__m-l-5___WwXd3 {
  margin-left: 5px !important;
}

.TablePagination-module__m-l-6___pKH9m {
  margin-left: 6px !important;
}

.TablePagination-module__m-l-8___W8iZD {
  margin-left: 8px !important;
}

.TablePagination-module__m-l-10___TGhwL {
  margin-left: 10px !important;
}

.TablePagination-module__m-l-16___uwNOY {
  margin-left: 16px !important;
}

.TablePagination-module__m-l-20___IeX0A {
  margin-left: 20px !important;
}

.TablePagination-module__m-l-24___ZU_uP {
  margin-left: 24px !important;
}

.TablePagination-module__m-l-30___d8cxJ {
  margin-left: 30px !important;
}

.TablePagination-module__m-l-35___GHpKS {
  margin-left: 35px !important;
}

.TablePagination-module__m-l-40___qqGIb {
  margin-left: 40px !important;
}

.TablePagination-module__m-r-8___q3cHQ {
  margin-right: 8px !important;
}

.TablePagination-module__m-r-10___FX5d8 {
  margin-right: 10px !important;
}

.TablePagination-module__m-r-16___j6qrf {
  margin-right: 16px !important;
}

.TablePagination-module__m-r-20___LA27s {
  margin-right: 20px !important;
}

.TablePagination-module__m-r-24___p9H4f {
  margin-right: 24px !important;
}

.TablePagination-module__m-r-30___uYb6x {
  margin-right: 30px !important;
}

.TablePagination-module__m-r-40___oXXvA {
  margin-right: 40px !important;
}

.TablePagination-module__border-r-3___GUAJT {
  border-radius: 3px !important;
}

.TablePagination-module__border-r-4___CXVdk {
  border-radius: 4px !important;
}

.TablePagination-module__border-r-6___HxUNm {
  border-radius: 6px !important;
}

.TablePagination-module__border-r-10___V5Mo9 {
  border-radius: 10px !important;
}

.TablePagination-module__border-r-12___ezeGP {
  border-radius: 12px !important;
}

.TablePagination-module__border-r-16___c5qvS {
  border-radius: 16px !important;
}

.TablePagination-module__border-r-50___UkHfh {
  border-radius: 50% !important;
}

.TablePagination-module__primary-border___jPdJw {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TablePagination-module__primary-border-b___xzYNW {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TablePagination-module__primary-border-t___Ngojl {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TablePagination-module__primary-border-l___RwtsF {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TablePagination-module__primary-border-r___SurhO {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TablePagination-module__secondary-border___dpUWr {
  border: 1px solid #637768;
}

.TablePagination-module__secondary-border-b___ng2eP {
  border-bottom: 1px solid #637768;
}

.TablePagination-module__secondary-border-t___VuzFt {
  border-top: 1px solid #637768;
}

.TablePagination-module__secondary-border-l___txjQf {
  border-left: 1px solid #637768;
}

.TablePagination-module__secondary-border-r___D0CcN {
  border-right: 1px solid #637768;
}

.TablePagination-module__gap-0___SdTX3 {
  gap: 0 !important;
}

.TablePagination-module__gap-2___gl41M {
  gap: 2px !important;
}

.TablePagination-module__gap-4___Oza0J {
  gap: 4px !important;
}

.TablePagination-module__gap-5___cNp3O {
  gap: 5px !important;
}

.TablePagination-module__gap-6___TpRYv {
  gap: 6px !important;
}

.TablePagination-module__gap-8___Mct20 {
  gap: 8px !important;
}

.TablePagination-module__gap-10___Tqp8e {
  gap: 10px !important;
}

.TablePagination-module__gap-12___Tpwr1 {
  gap: 12px !important;
}

.TablePagination-module__gap-14___duohg {
  gap: 14px !important;
}

.TablePagination-module__gap-16___ptOCc {
  gap: 16px !important;
}

.TablePagination-module__gap-18___WSbmL {
  gap: 18px !important;
}

.TablePagination-module__gap-20___I9eRn {
  gap: 20px !important;
}

.TablePagination-module__gap-24___uKnIL {
  gap: 24px !important;
}

.TablePagination-module__gap-26___JA3oS {
  gap: 26px !important;
}

.TablePagination-module__gap-30___k80uq {
  gap: 30px !important;
}

.TablePagination-module__gap-32___XsAhQ {
  gap: 32px !important;
}

.TablePagination-module__gap-40___Bw054 {
  gap: 40px !important;
}

.TablePagination-module__gap-50___KFOO_ {
  gap: 50px !important;
}

.TablePagination-module__flex-1___ThAYU {
  flex: 1;
}

.TablePagination-module__flex-none___D7HkK {
  flex: none !important;
}

.TablePagination-module__flex-column___BwJ_U {
  display: flex;
  flex-direction: column !important;
}

.TablePagination-module__flex-row___ik2Eb {
  display: flex;
  flex-direction: row !important;
}

.TablePagination-module__vertically-centered___dPj2c {
  display: flex;
  align-items: center !important;
}

.TablePagination-module__horizontally-centered___GNZcK {
  display: flex;
  justify-content: center !important;
}

.TablePagination-module__horizontally-end___iKtAX {
  display: flex;
  justify-content: end !important;
}

.TablePagination-module__vertically-start___eF9Qy {
  display: flex;
  align-items: start !important;
}

.TablePagination-module__space-between___OeTsy {
  display: flex;
  justify-content: space-between !important;
}

.TablePagination-module__flex-wrap___YplRM {
  flex-wrap: wrap !important;
}

.TablePagination-module__height-100___dsnZ5 {
  height: 100%;
}

.TablePagination-module__width-50___E2Ajh {
  width: 50% !important;
}

.TablePagination-module__width-100___TvWTo {
  width: 100%;
}

.TablePagination-module__cursor-pointer___Euwit {
  cursor: pointer;
}

.TablePagination-module__cursor-not-allowed___r34wy {
  cursor: not-allowed !important;
}

.TablePagination-module__absolute-centered___XpMFs {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TablePagination-module__absolute___WEECe {
  position: absolute;
}

.TablePagination-module__relative___YObgu {
  position: relative;
}

.TablePagination-module__fixed___nIbVq {
  position: fixed;
}

.TablePagination-module__visible___L51eR {
  opacity: 1;
}

.TablePagination-module__invisible___WqiJX {
  opacity: 0;
}

.TablePagination-module__col-90___dDE44 {
  width: 90% !important;
}

.TablePagination-module__col-auto___o6Mxd {
  width: auto !important;
}

.TablePagination-module__medical-tabs___A9F9U {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TablePagination-module__medical-table-new___lQoBi {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TablePagination-module__medical-table-new___lQoBi:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TablePagination-module__medical-table-new___lQoBi::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TablePagination-module__medical-table-new___lQoBi::-webkit-scrollbar-track {
  display: none;
}
.TablePagination-module__medical-table-new___lQoBi.TablePagination-module__no-pagination___QdhSp {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TablePagination-module__medical-table-new___lQoBi.TablePagination-module__no-pagination___QdhSp:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TablePagination-module__medical-table-new___lQoBi.TablePagination-module__no-pagination___QdhSp::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TablePagination-module__medical-table-new___lQoBi.TablePagination-module__no-pagination___QdhSp::-webkit-scrollbar-track {
  display: none;
}

.TablePagination-module__medical-table-empty___FBSL7 {
  padding: 14px 40px !important;
}

.TablePagination-module__icon-btn___Xm47O {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TablePagination-module__search-icon___hEHdJ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TablePagination-module__disable-select___mASGM {
  user-select: none;
}

.TablePagination-module__break-word___id5QI {
  word-break: break-word;
}

.TablePagination-module__popup-clear-btn___HdwTD {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TablePagination-module__scroll-m-b-20___tzsrM {
  scroll-margin-bottom: 20px;
}

.TablePagination-module__pagination___etL2a {
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.08);
  border-top: 1px solid #e0e1e2;
  border-bottom: 1px solid #e0e1e2;
}
.TablePagination-module__pagination___etL2a > * {
  min-width: 34px;
  min-height: 34px;
  font-size: 14px;
  line-height: 16px;
}
.TablePagination-module__pagination___etL2a .TablePagination-module__button___p5CpW {
  color: #375844;
  text-align: center;
}
.TablePagination-module__pagination___etL2a .TablePagination-module__button___p5CpW.TablePagination-module__selected___C0dcQ {
  background-color: #375844;
  color: white;
}
.TablePagination-module__pagination___etL2a .TablePagination-module__arrowButton___QNByb {
  display: flex;
  border-radius: 3px 0 0 3px;
  align-items: center;
  justify-content: center;
}

.TablePagination-module__select___tc4H4 {
  width: 70px;
  min-height: 34px;
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.08);
}
.TablePagination-module__select___tc4H4 > div:first-child {
  padding: 8.5px !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/table/TablePagination/TablePagination.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,+CAAA;EACA,6BAAA;EACA,gCAAA;AA8pBF;AA5pBE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA8pBJ;AA3pBE;EACE,cAAA;EACA,kBAAA;AA6pBJ;AA3pBI;EACE,yBAAA;EACA,YAAA;AA6pBN;AAzpBE;EACE,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,uBAAA;AA2pBJ;;AAvpBA;EACE,WAAA;EACA,gBAAA;EACA,+CAAA;AA0pBF;AAxpBE;EACE,yBAAA;AA0pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.pagination {\n  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.08);\n  border-top: 1px solid #e0e1e2;\n  border-bottom: 1px solid #e0e1e2;\n\n  & > * {\n    min-width: 34px;\n    min-height: 34px;\n    font-size: 14px;\n    line-height: 16px;\n  }\n\n  .button {\n    color: get-color(greenNew, dark);\n    text-align: center;\n\n    &.selected {\n      background-color: get-color(greenNew, dark);\n      color: white;\n    }\n  }\n\n  .arrowButton {\n    display: flex;\n    border-radius: 3px 0 0 3px;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.select {\n  width: 70px;\n  min-height: 34px;\n  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.08);\n\n  & > div:first-child {\n    padding: 8.5px !important;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TablePagination-module__font-s-10___zwu9f`,
	"fontS12": `TablePagination-module__font-s-12___t9jY0`,
	"fontS13": `TablePagination-module__font-s-13___ieKm3`,
	"fontS14": `TablePagination-module__font-s-14___Wox6M`,
	"fontS15": `TablePagination-module__font-s-15___w72ng`,
	"fontS16": `TablePagination-module__font-s-16___yfVb5`,
	"fontS18": `TablePagination-module__font-s-18___LZhli`,
	"fontS20": `TablePagination-module__font-s-20___BgY9y`,
	"fontS22": `TablePagination-module__font-s-22___bLHxd`,
	"fontS28": `TablePagination-module__font-s-28___GsFe7`,
	"fontW400": `TablePagination-module__font-w-400___BrHGw`,
	"fontW500": `TablePagination-module__font-w-500___dFZTq`,
	"fontW600": `TablePagination-module__font-w-600___dFoOm`,
	"fontW700": `TablePagination-module__font-w-700___rP0a5`,
	"p5": `TablePagination-module__p-5___ix7TR`,
	"p12": `TablePagination-module__p-12___rch1B`,
	"p16": `TablePagination-module__p-16___WwLRc`,
	"p30": `TablePagination-module__p-30___kaBzE`,
	"pB0": `TablePagination-module__p-b-0___aS9nk`,
	"pB5": `TablePagination-module__p-b-5___YqFPp`,
	"pB10": `TablePagination-module__p-b-10___KFgmQ`,
	"pB12": `TablePagination-module__p-b-12___z5WwU`,
	"pB16": `TablePagination-module__p-b-16___fQbvL`,
	"pB18": `TablePagination-module__p-b-18___nDhp8`,
	"pB20": `TablePagination-module__p-b-20___XLNZr`,
	"pB25": `TablePagination-module__p-b-25___PCURg`,
	"pB30": `TablePagination-module__p-b-30___LxHCE`,
	"pB50": `TablePagination-module__p-b-50___ia85f`,
	"pT0": `TablePagination-module__p-t-0___la6_p`,
	"pT12": `TablePagination-module__p-t-12___eSOCn`,
	"pT16": `TablePagination-module__p-t-16___l12w3`,
	"pT18": `TablePagination-module__p-t-18___rm5ww`,
	"pT20": `TablePagination-module__p-t-20___njxbO`,
	"pT30": `TablePagination-module__p-t-30___uL9jX`,
	"pT40": `TablePagination-module__p-t-40___OGFJj`,
	"pT50": `TablePagination-module__p-t-50___Hs9k1`,
	"pL20": `TablePagination-module__p-l-20___nJ8N8`,
	"pL30": `TablePagination-module__p-l-30___bDRqQ`,
	"pL40": `TablePagination-module__p-l-40___H043i`,
	"pR16": `TablePagination-module__p-r-16___h_W9B`,
	"pR20": `TablePagination-module__p-r-20___XkYbs`,
	"pR30": `TablePagination-module__p-r-30___r61bv`,
	"pR50": `TablePagination-module__p-r-50___HMMbx`,
	"pR60": `TablePagination-module__p-r-60___ts0VB`,
	"mB1": `TablePagination-module__m-b-1___p4PwW`,
	"mB2": `TablePagination-module__m-b-2___gk7Me`,
	"mB6": `TablePagination-module__m-b-6___O0ilU`,
	"mB8": `TablePagination-module__m-b-8___YSNUB`,
	"mB10": `TablePagination-module__m-b-10___ECNlA`,
	"mB14": `TablePagination-module__m-b-14___oUfHP`,
	"mB16": `TablePagination-module__m-b-16___eJZhj`,
	"mB20": `TablePagination-module__m-b-20___17Qjp`,
	"mB22": `TablePagination-module__m-b-22___rJuNB`,
	"mB24": `TablePagination-module__m-b-24___vjQYa`,
	"mB30": `TablePagination-module__m-b-30___kWt8o`,
	"mB32": `TablePagination-module__m-b-32___pRP1f`,
	"mB40": `TablePagination-module__m-b-40___Cdsps`,
	"mT2": `TablePagination-module__m-t-2___jDtGC`,
	"mT3": `TablePagination-module__m-t-3___AmTW0`,
	"mT4": `TablePagination-module__m-t-4___nlGIz`,
	"mT5": `TablePagination-module__m-t-5___dljOZ`,
	"mT8": `TablePagination-module__m-t-8___mzqd5`,
	"mT10": `TablePagination-module__m-t-10___DVRZx`,
	"mT15": `TablePagination-module__m-t-15___MuTY4`,
	"mT16": `TablePagination-module__m-t-16___wvh2S`,
	"mT20": `TablePagination-module__m-t-20___xivAq`,
	"mT22": `TablePagination-module__m-t-22___gyyFa`,
	"mT30": `TablePagination-module__m-t-30___P8fYU`,
	"mT32": `TablePagination-module__m-t-32___ornZF`,
	"mLAuto": `TablePagination-module__m-l-auto___e2cd3`,
	"mL4": `TablePagination-module__m-l-4___QVEnQ`,
	"mL5": `TablePagination-module__m-l-5___WwXd3`,
	"mL6": `TablePagination-module__m-l-6___pKH9m`,
	"mL8": `TablePagination-module__m-l-8___W8iZD`,
	"mL10": `TablePagination-module__m-l-10___TGhwL`,
	"mL16": `TablePagination-module__m-l-16___uwNOY`,
	"mL20": `TablePagination-module__m-l-20___IeX0A`,
	"mL24": `TablePagination-module__m-l-24___ZU_uP`,
	"mL30": `TablePagination-module__m-l-30___d8cxJ`,
	"mL35": `TablePagination-module__m-l-35___GHpKS`,
	"mL40": `TablePagination-module__m-l-40___qqGIb`,
	"mR8": `TablePagination-module__m-r-8___q3cHQ`,
	"mR10": `TablePagination-module__m-r-10___FX5d8`,
	"mR16": `TablePagination-module__m-r-16___j6qrf`,
	"mR20": `TablePagination-module__m-r-20___LA27s`,
	"mR24": `TablePagination-module__m-r-24___p9H4f`,
	"mR30": `TablePagination-module__m-r-30___uYb6x`,
	"mR40": `TablePagination-module__m-r-40___oXXvA`,
	"borderR3": `TablePagination-module__border-r-3___GUAJT`,
	"borderR4": `TablePagination-module__border-r-4___CXVdk`,
	"borderR6": `TablePagination-module__border-r-6___HxUNm`,
	"borderR10": `TablePagination-module__border-r-10___V5Mo9`,
	"borderR12": `TablePagination-module__border-r-12___ezeGP`,
	"borderR16": `TablePagination-module__border-r-16___c5qvS`,
	"borderR50": `TablePagination-module__border-r-50___UkHfh`,
	"primaryBorder": `TablePagination-module__primary-border___jPdJw`,
	"primaryBorderB": `TablePagination-module__primary-border-b___xzYNW`,
	"primaryBorderT": `TablePagination-module__primary-border-t___Ngojl`,
	"primaryBorderL": `TablePagination-module__primary-border-l___RwtsF`,
	"primaryBorderR": `TablePagination-module__primary-border-r___SurhO`,
	"secondaryBorder": `TablePagination-module__secondary-border___dpUWr`,
	"secondaryBorderB": `TablePagination-module__secondary-border-b___ng2eP`,
	"secondaryBorderT": `TablePagination-module__secondary-border-t___VuzFt`,
	"secondaryBorderL": `TablePagination-module__secondary-border-l___txjQf`,
	"secondaryBorderR": `TablePagination-module__secondary-border-r___D0CcN`,
	"gap0": `TablePagination-module__gap-0___SdTX3`,
	"gap2": `TablePagination-module__gap-2___gl41M`,
	"gap4": `TablePagination-module__gap-4___Oza0J`,
	"gap5": `TablePagination-module__gap-5___cNp3O`,
	"gap6": `TablePagination-module__gap-6___TpRYv`,
	"gap8": `TablePagination-module__gap-8___Mct20`,
	"gap10": `TablePagination-module__gap-10___Tqp8e`,
	"gap12": `TablePagination-module__gap-12___Tpwr1`,
	"gap14": `TablePagination-module__gap-14___duohg`,
	"gap16": `TablePagination-module__gap-16___ptOCc`,
	"gap18": `TablePagination-module__gap-18___WSbmL`,
	"gap20": `TablePagination-module__gap-20___I9eRn`,
	"gap24": `TablePagination-module__gap-24___uKnIL`,
	"gap26": `TablePagination-module__gap-26___JA3oS`,
	"gap30": `TablePagination-module__gap-30___k80uq`,
	"gap32": `TablePagination-module__gap-32___XsAhQ`,
	"gap40": `TablePagination-module__gap-40___Bw054`,
	"gap50": `TablePagination-module__gap-50___KFOO_`,
	"flex1": `TablePagination-module__flex-1___ThAYU`,
	"flexNone": `TablePagination-module__flex-none___D7HkK`,
	"flexColumn": `TablePagination-module__flex-column___BwJ_U`,
	"flexRow": `TablePagination-module__flex-row___ik2Eb`,
	"verticallyCentered": `TablePagination-module__vertically-centered___dPj2c`,
	"horizontallyCentered": `TablePagination-module__horizontally-centered___GNZcK`,
	"horizontallyEnd": `TablePagination-module__horizontally-end___iKtAX`,
	"verticallyStart": `TablePagination-module__vertically-start___eF9Qy`,
	"spaceBetween": `TablePagination-module__space-between___OeTsy`,
	"flexWrap": `TablePagination-module__flex-wrap___YplRM`,
	"height100": `TablePagination-module__height-100___dsnZ5`,
	"width50": `TablePagination-module__width-50___E2Ajh`,
	"width100": `TablePagination-module__width-100___TvWTo`,
	"cursorPointer": `TablePagination-module__cursor-pointer___Euwit`,
	"cursorNotAllowed": `TablePagination-module__cursor-not-allowed___r34wy`,
	"absoluteCentered": `TablePagination-module__absolute-centered___XpMFs`,
	"absolute": `TablePagination-module__absolute___WEECe`,
	"relative": `TablePagination-module__relative___YObgu`,
	"fixed": `TablePagination-module__fixed___nIbVq`,
	"visible": `TablePagination-module__visible___L51eR`,
	"invisible": `TablePagination-module__invisible___WqiJX`,
	"col90": `TablePagination-module__col-90___dDE44`,
	"colAuto": `TablePagination-module__col-auto___o6Mxd`,
	"medicalTabs": `TablePagination-module__medical-tabs___A9F9U`,
	"medicalTableNew": `TablePagination-module__medical-table-new___lQoBi`,
	"noPagination": `TablePagination-module__no-pagination___QdhSp`,
	"medicalTableEmpty": `TablePagination-module__medical-table-empty___FBSL7`,
	"iconBtn": `TablePagination-module__icon-btn___Xm47O`,
	"searchIcon": `TablePagination-module__search-icon___hEHdJ`,
	"disableSelect": `TablePagination-module__disable-select___mASGM`,
	"breakWord": `TablePagination-module__break-word___id5QI`,
	"popupClearBtn": `TablePagination-module__popup-clear-btn___HdwTD`,
	"scrollMB20": `TablePagination-module__scroll-m-b-20___tzsrM`,
	"pagination": `TablePagination-module__pagination___etL2a`,
	"button": `TablePagination-module__button___p5CpW`,
	"selected": `TablePagination-module__selected___C0dcQ`,
	"arrowButton": `TablePagination-module__arrowButton___QNByb`,
	"select": `TablePagination-module__select___tc4H4`
};
module.exports = ___CSS_LOADER_EXPORT___;
